<template>
  <v-app id="inspire">
    <my-side-bar :drawer="drawer"></my-side-bar>
    <my-header @changeDrawer="updateDrawer" :drawer="drawer" ></my-header>
    
    <v-main>
      <v-container class="" fluid >
        <v-row class="px-3">
          <v-card class="col-12">
            <v-card-title>
              Gestione Ruoli Applicativo
              <v-spacer></v-spacer>
            </v-card-title>
           <div>
              <v-row class="row-btn" v-if="userLoggedPermissions.manage_user_roles !== undefined && userLoggedPermissions.manage_user_roles.write">
                <v-btn color="success" class="mr-4" @click="addRole">
                  <v-icon>mdi-plus-thick</v-icon>
                </v-btn>
              </v-row>
            <vue-good-table
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: serverParams.perPage,
                position: 'bottom',
                perPageDropdown: [10, 20, 50],
                dropdownAllowAll: false,
                setCurrentPage: serverParams.page,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
              }"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :columns="columns"
              :rows="rows"
              styleClass="vgt-table bordered striped">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <div class="text-center">
                    <v-btn icon rounded x-small title="Edit" v-if="userLoggedPermissions.manage_user_role_permissions">
                      <v-icon dark v-on:click="editRole(props.row)">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn icon rounded x-small title="Delete" v-if="userLoggedPermissions.manage_user_roles.delete">
                      <v-icon dark v-on:click="deleteRole(props.row)">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                
              </template> 
            </vue-good-table>
          </div>
          </v-card>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import SideBar from '../components/SideBar.vue';
  import Header from '../components/Header.vue';
  
  import { VueGoodTable } from 'vue-good-table';
  // import the styles
  import 'vue-good-table/dist/vue-good-table.css'
  import { rolesUrl, permissionsUrl, getHeader } from '../config.js';
  import router from '../router';
  import { store } from '../store';

  const axios = require('axios');

  export default {
    props: {
      source: String,
    },
    components:{
      'my-side-bar':SideBar,
      'my-header':Header,
      VueGoodTable
    },
    data: () => ({
      dialog: false,
      drawer: true,
      columns: [
        {
          
          width:'20%',
          label: '#',
          field: 'id',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            //filterValue: 'Jane', // initial populated value for this filter
            //filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //customFilter: true,
            //filterFn: this.columnFilterFn, //custom filter function that
            //trigger: 'enter', //only trigger on enter not on keyup 
          },
        },
        {
          
          width:'75%',
          label: 'Nome',
          field: 'role_name',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            //filterValue: 'Jane', // initial populated value for this filter
            //filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //customFilter: true,
            //filterFn: this.columnFilterFn, //custom filter function that
            //trigger: 'enter', //only trigger on enter not on keyup 
          },
        },
        {
          width:'5%',
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: [],
        sort: [],
        page: 1, 
        perPage: 10
      },
      userLogged: {},
      userLoggedPermissions: {}
    }),
    watch: {
    },
    mounted () {

      this.userLogged = store.state.user;
      this.userLoggedPermissions = store.state.permissions;

      if(this.userLoggedPermissions.manage_user_roles === undefined){
        this.$fire({
          title: "Accesso Negato",
          text: "Non si hanno i privilegi per accedere a questa pagina",
          type: "error",
          timer: 5000
        }).then(r => {
          console.log(r.value);
        });

        router.push({name:'Home'});

      }else{
        this.loadItems();
      }
       
    },
    methods: {
      updateDrawer(value){
        this.drawer = value;
      },
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage});
        this.loadItems();
      },

      onSortChange(params) {
        var sort = [];
        params.forEach(function(item){
          sort.push(
            {
              type: item.type,
              field: item.field
            }
          );
        });
        this.updateParams({sort: sort});
        this.loadItems();
      },
      
      onColumnFilter(params) {
        var filter = [];
        Object.keys(params.columnFilters).forEach(function(item){
          filter.push(
            {
              field: item,
              term: params.columnFilters[item]
            }
          );
        });
        this.updateParams({columnFilters:filter});
        this.loadItems();
      },

      // load items is what brings back the rows from server
      loadItems() {
        this.isLoading = true;
        this.getFromServer(this.serverParams).then(response => {
          this.totalRecords = response.total;
          this.rows = response.items;
          this.isLoading = false;
          console.log('rows', this.rows);
        });
      },
      getFromServer(params){

        var header = getHeader();

        var q = '?page=' + params.page + '&size=' + params.perPage
        var sort = [];
        var filter = [];

        if(params.sort.length > 0){
          params.sort.forEach(function(s){
            sort.push(s.field + ':' + s.type); 
          });
        }

        var qSort = sort.join(',');

        if(params.columnFilters.length > 0){
          params.columnFilters.forEach(function(f){
            filter.push(f.field + ':' + f.term); 
          });
        }

        var qFilter = filter.join(',');

        q += '&sort_by=' + qSort + '&filter_by=' + qFilter;

        return axios.get(rolesUrl + q, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);

                var list = [];
                var count = response.data.totRows;
                response.data.rows.forEach(function(item){
                  list.push(
                    {
                      id: item.id,
                      role_name: item.role_name
                    }
                  );
                });

                return {items : list, total : count}

            })
            .catch(function (error) {
                // handle error
                alert(error)
            });

      },
      editRole(row){
        router.push({ name: 'Role', params: { roleId: row.id } });
      },
      addRole(){
        router.push({ name: 'Role', params: { roleId: 0 } });
      },
      deleteRole(row){
        
        this.$fire({
          title: 'Sei sicuro?',
          text: "L'operazione non sarà reversibile!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cancella!'
        }).then(r => {
            if(r.value){
              
              this.isLoading = true;

              var header = getHeader();

              axios.delete(permissionsUrl + '/' + row.id, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.affected == "1"){
                  
                  this.$fire({
                    title: "Cancellato!",
                    text: "Ruolo cancellato con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.loadItems();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "E' avvenuto un errore, si prega di riprovare.";
                  this.$fire({
                    title: "Errore!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }
        });

      }

    },
    computed: {
      user(){
        return this.$store.state.user;
      }
    }
  }
</script>

<style scoped>
.row .row-btn{
  padding:12px;
  text-align: right;
  display: block;
}
</style>